import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * On route change, scroll to #anchor if present; otherwise scroll to top.
 * Needed because React Router doesn't auto-scroll to anchors across route changes.
 */
export default function ScrollToHash() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      // Wait for paint so the target exists
      const id = hash.replace("#", "");
      const tryScroll = () => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
        } else {
          window.scrollTo({ top: 0 });
        }
      };
      const t = setTimeout(tryScroll, 60);
      return () => clearTimeout(t);
    }
    window.scrollTo({ top: 0 });
  }, [pathname, hash]);

  return null;
}
